import { render } from "./HeroIcon.vue?vue&type=template&id=468ee63f&ts=true"
import script from "./HeroIcon.vue?vue&type=script&lang=ts"
export * from "./HeroIcon.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/nice-life-contract/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__